import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { BasicInfoHttpGetService } from '../../Services/BasicInfoHttpService';
import { IGetMenuContentByIdQuery } from '../../Types/Queries/IGetMenuContentByIdQuery';

export const getMenuContentById = createAsyncThunk(
  'basicinfo/getMenuContentById',
  async (query: IGetMenuContentByIdQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.MenuContent.GetMenuContentById}`,
      params: query,
    });
  }
);
